import { useEffect, useState } from 'react';
import axios from 'axios';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { Form, Input, Button, Upload } from 'antd';
import Swal from 'sweetalert2';
import './AdminDashboard.css';

const API_BASE_URL = 'https://la-idea-backend.onrender.com';

function FormHomeBanner() {
  const [fileList, setFileList] = useState([]);
  const [title, setTitle] = useState('');
  const [currentBanner, setCurrentBanner] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const fetchCurrentBanner = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/banner`);
      setCurrentBanner(response.data);
    } catch (error) {
      if (error.response?.status !== 404) {
        console.error('Error fetching current banner:', error);
      }
      setCurrentBanner(null);
    }
  };

  useEffect(() => {
    fetchCurrentBanner();
  }, []);

  const handleFileChange = ({ fileList: newFileList }) => {
    const file = newFileList[0];

    if (file && !file.type.startsWith('image/')) {
      Swal.fire({
        icon: 'error',
        title: 'Formato no compatible',
        text: 'Subi una imagen valida para el banner.',
      });
      setFileList([]);
      return;
    }

    setFileList(newFileList.slice(-1));
  };

  const handleSubmit = async () => {
    if (fileList.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Falta la imagen',
        text: 'Selecciona una imagen antes de guardar.',
      });
      return;
    }

    const formData = new FormData();
    formData.append('title', title || 'Banner principal');
    formData.append('imageUrl', fileList[0].originFileObj);

    try {
      setIsSubmitting(true);
      await axios.post(`${API_BASE_URL}/banner`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      Swal.fire({
        icon: 'success',
        title: 'Banner actualizado',
        text: 'El nuevo banner del inicio ya quedo publicado.',
      });

      setTitle('');
      setFileList([]);
      fetchCurrentBanner();
    } catch (error) {
      console.error('Error updating banner:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo actualizar el banner.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDeleteBanner = async () => {
    const result = await Swal.fire({
      icon: 'warning',
      title: 'Eliminar banner',
      text: 'El inicio quedara sin banner activo.',
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d33',
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      setIsDeleting(true);
      await axios.delete(`${API_BASE_URL}/banner`);
      setCurrentBanner(null);

      Swal.fire({
        icon: 'success',
        title: 'Banner eliminado',
        text: 'El inicio quedo sin banner activo.',
      });
    } catch (error) {
      console.error('Error deleting banner:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo eliminar el banner.',
      });
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="form-ant">
      <Form
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 14 }}
        layout="horizontal"
        style={{ maxWidth: 700 }}
        onFinish={handleSubmit}
      >
        <h1>Banner de inicio</h1>

        {currentBanner?.imageUrl && (
          <div className="banner-preview-card">
            <p className="banner-preview-label">Banner activo</p>
            <img src={currentBanner.imageUrl} alt={currentBanner.title || 'Banner activo'} className="banner-preview-image" />
            <Button
              danger
              icon={<DeleteOutlined />}
              loading={isDeleting}
              onClick={handleDeleteBanner}
              className="banner-delete-button"
            >
              Eliminar banner
            </Button>
          </div>
        )}

        <Form.Item label="Titulo">
          <Input
            name="title"
            placeholder="Banner principal"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </Form.Item>

        <Form.Item label="Imagen">
          <Upload
            fileList={fileList}
            onChange={handleFileChange}
            beforeUpload={() => false}
            listType="picture-card"
          >
            {fileList.length < 1 && (
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Upload</div>
              </div>
            )}
          </Upload>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={isSubmitting}>
            Guardar banner
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}

export { FormHomeBanner };
